/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { Chip } from "@mui/material";

const getStatusColor = (status) => {
    switch (status) {
      case "accepted":
        return "success";
      case "pending":
        return "warning";
      case "rejected":
        return "error";
      default:
        return "default";
    }
};
  

export default function data({shiftRequets = [], editAction}) {
 
  const rows = shiftRequets.map((shiftRequest) => {
    return {
        type: shiftRequest?.job?.type,
        status: <Chip
            label={shiftRequest.status}
            color={getStatusColor(shiftRequest.status)}
            variant="outlined"
            size="small"
            sx={{ textTransform: "capitalize", fontWeight: "bold" }}
        />,
        targetDate: shiftRequest.date,
        targetShift: shiftRequest.shiftType,
        requestedDate: shiftRequest?.job?.requestedShift ? new Date(shiftRequest?.job?.requestedShift?.day).toISOString().split("T")[0]: "",
        requestedShift: shiftRequest?.job?.requestedShift?.shift,
    }
  });


  return {
    columns: [
      { Header: "Type", accessor: "type", align: "left" },
      { Header: "Status", accessor: "status", align: "left" },
      { Header: "Target Date", accessor: "targetDate", align: "left" },
      { Header: "Target Shift", accessor: "targetShift", align: "left" },
      { Header: "Requested Date", accessor: "requestedDate", align: "left" },
      { Header: "Requested Shift", accessor: "requestedShift", align: "left" },
    ],

    rows: rows,
  };
}
